/** Utilidades compartidas para Excel comerciales (Packing / Invoice PTC / PTB). */

export const THIN = { style: 'thin', color: { argb: 'FF000000' } };
export const BORDER = { top: THIN, left: THIN, bottom: THIN, right: THIN };

export function safe(s) {
  return s == null ? '' : String(s);
}

export function upper(s) {
  const t = safe(s).trim();
  return t ? t.toUpperCase() : '';
}

export function styleRange(ws, r1, c1, r2, c2, style) {
  for (let r = r1; r <= r2; r += 1) {
    for (let c = c1; c <= c2; c += 1) {
      const cell = ws.getCell(r, c);
      if (style.border) cell.border = style.border;
      if (style.fill) cell.fill = style.fill;
      if (style.font) cell.font = { ...cell.font, ...style.font };
      if (style.alignment) cell.alignment = { ...cell.alignment, ...style.alignment };
    }
  }
}

export function writeRow(ws, rowIndex, values, opts = {}) {
  const row = ws.getRow(rowIndex);
  values.forEach((v, i) => {
    const cell = row.getCell(i + 1);
    cell.value = v === '' || v === undefined ? null : v;
    if (opts.border) cell.border = BORDER;
    if (opts.font) cell.font = { ...cell.font, ...opts.font };
    if (opts.fill) cell.fill = opts.fill;
    if (opts.align) cell.alignment = opts.align;
    if (opts.wrap) cell.alignment = { ...(cell.alignment || {}), wrapText: true, ...opts.align };
  });
  if (opts.height) row.height = opts.height;
  return row;
}

export function downloadWorkbook(buffer, fname) {
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fname;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export async function workbookToDownload(wb, fname) {
  const buffer = await wb.xlsx.writeBuffer();
  downloadWorkbook(buffer, fname);
}

export function fmtNumCL(v, decimals = 3) {
  if (v == null || v === '' || Number.isNaN(Number(v))) return '';
  return new Intl.NumberFormat('es-CL', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number(v));
}

export function fmtPriceEs(v) {
  if (v == null || v === '' || Number.isNaN(Number(v))) return '';
  const n = Number(v);
  const [intPart, decPart = ''] = n.toFixed(2).split('.');
  const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${withThousands},${decPart}`;
}

export function fmtDateLongEn(isoDate) {
  if (!isoDate) return '';
  const d = new Date(`${String(isoDate).slice(0, 10)}T12:00:00`);
  if (Number.isNaN(d.getTime())) return safe(isoDate);
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
}

export function setColWidths(ws, widths) {
  widths.forEach((w, i) => {
    ws.getColumn(i + 1).width = w;
  });
}
